export const formatDate = (
  date: Date | string | undefined | null,
  withTime = false,
  formatOptions?: Intl.DateTimeFormatOptions,
) => {
  if (!date) {
    return "-";
  }

  const options: Intl.DateTimeFormatOptions = !withTime
    ? {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }
    : {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };
  const format = new Intl.DateTimeFormat("cs", formatOptions ?? options);

  return format.format(new Date(date));
};

export const clearDateTime = (date: Date | string, hours?: number) => {
  const newDate = new Date(date);

  newDate.setHours(hours ?? 0);
  newDate.setMinutes(0);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);

  return newDate;
};

export const clearDateDay = (date: Date | string, hours?: number) => {
  const newDate = new Date(date);

  newDate.setDate(1);
  newDate.setHours(hours ?? 0);
  newDate.setMinutes(0);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);

  return newDate;
};

export const formatMonthWithYear = (date: Date | string | undefined | null) => {
  if (!date) {
    return "-";
  }

  const d = new Date(date);
  return `${d.getMonth() + 1}. ${d.getFullYear()}`;
};
